import React from 'react'
import { UserInfo } from '@Entities/user/user'

interface EmailStatusBlockProps {
    userData: UserInfo
    lastActivityDateString: string
}

const EmailStatusBlock = (props: EmailStatusBlockProps) => {
    const { email, verificationStatus } = props.userData
    const { lastActivityDateString } = props

    return (
        <div className="email-status-block">
            {email ? (
                <p>
                    Email: <b>{email}</b>
                </p>
            ) : null}
            {verificationStatus ? (
                <p>
                    Status: <b>{verificationStatus}</b>
                </p>
            ) : null}
            {lastActivityDateString && (
                <p className="last-activity mobile">
                    Last Activity: <b>{lastActivityDateString}</b>
                </p>
            )}
        </div>
    )
}

export default EmailStatusBlock
